import React from 'react';
import {AddLink} from "@mui/icons-material";

function AddLinkIcon(props) {
  return <AddLink {...props} style={{transform:'rotateX(180deg)'}} />;
}

export default AddLinkIcon;
